import VueRouter from "vue-router";
import { Auth, API, graphqlOperation } from 'aws-amplify';

import AuthComponent from './components/Auth';
import DashboardComponent from "./components/Dashboard";
import ResolveComponent from "./components/Resolve";
import NewRequestComponent from "./components/NewRequest";
import AdminComponent from "./components/Admin";
import ViewRequestComponent from "./components/ViewRequest";

const routes = [
    { path: '/', component: DashboardComponent, meta: { requiresAuth: true }, props: true },
    { path: '/auth', component: AuthComponent, meta: { header: false, footer: false  } },
    { path: '/request', component: NewRequestComponent, meta: { requiresAuth: true } },
    { path: '/admin', component: AdminComponent, meta: { requiresAuth: true, adminOnly: true } },
    { path: '/resolve', component: ResolveComponent, meta: { header: false, footer: false }, props: (route) => ({ s3Key: route.query.s3Key })},
    { path: '/view', component: ViewRequestComponent, meta: { requiresAuth: true, footer: false }, props: (route) => ({ id: route.query.id })}
];

const router = new VueRouter({
    routes
});

router.beforeResolve((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        Auth.currentAuthenticatedUser().then(async (data) => {
            if (to.matched.some(record => record.meta.adminOnly)) {
                const userGroups = data.signInUserSession.accessToken.payload['cognito:groups'];
                if (userGroups.includes("Admins")) {
                    next();
                } else {
                    next({
                        path: '/'
                    });
                }
            }
            next()
        }).catch(() => {
            next({
                path: '/auth'
            });
        });
    }
    next()
});

export default router